/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IAccountCustomerBalanceTileViewProps } from './account-customer-balance-tile';

const AccountCustomerBalanceTileView: React.FC<IAccountCustomerBalanceTileViewProps> = props => {
    const { AccountCustomerBalanceTile, heading, content, links } = props;

    return (
        <Module {...AccountCustomerBalanceTile}>
            {heading}
            {content}
            {links}
        </Module>
    );
};

export default AccountCustomerBalanceTileView;
